import React from 'react';
import { Box, Text, Divider, Image , Grid} from '@chakra-ui/react';

const Section = () => {
  return (
    <Box w="full" mt='1.5rem' mb='1.5rem' h={['100%', '100%', '100%', '25vh']}>
      <Box
        display="flex"
        px="1rem"
        justifyContent="space-evenly"
      >
        <Text
          color="#A0A4A8"
          fontFamily="Work Sans"
          textTransform="uppercase"
          whiteSpace="nowrap"
          fontSize={['.75rem', '.8rem', '.8rem', '1rem']}
          letterSpacing={[0, 0, 0, 2]}
          fontWeight="500"
        >
          trusted by
        </Text>
        <Divider mt='.85rem' color="#E5E5E5"  />
      </Box>
      {/* <Box
        w="full"
        mt="3rem"
        display="flex"
        gap="12"
        mb="1rem"
        alignItems="center"
        flexWrap="wrap"
        justifyContent="center"
      >
        <Image src="/Logo.png" boxSize={['20%', '10%']} alt="" />
        <Image src="/Logo.png" boxSize={['20%', '10%']} alt="" />
        <Image src="/Logo.png" boxSize={['20%', '10%']} alt="" />
        <Image src="/Logo.png" boxSize={['20%', '10%']} alt="" />
        <Image src="/Logo.png" boxSize={['20%', '10%']} alt="" />
      </Box> */}
      <Grid px='2rem'mt='1rem' templateColumns={['repeat(3,1fr)','repeat(5,1fr)']} gap='6'>
        <Image src="/Logo.png" w={['60px','121px']} h={['12px','27px']} alt="" />
        <Image src="/s.png" w={['60px','121px']} h={['12px','27px']} alt="" />
        <Image src="/u.png" w={['60px','121px']} h={['12px','27px']} alt="" />
        <Image src="/m.png" w={['60px','121px']} h={['12px','27px']} alt="" />
        <Image src="/Logo.png" w={['60px','121px']} h={['12px','27px']} alt="" />
      </Grid>
    </Box>
  );
};

export default Section;
